export const Black = '#181A1F';
export const Surface = '#1C1F25';
export const WidgetBackground = '#1A1D22';
export const CardBackground = '#20242B';
export const InputBackground = '#1F2228';
export const Gray = Surface;
export const DarkGray = Surface;

export const White = '#FFFFFF';
export const LightGray = '#FFFFFF80';
export const HelperText = '#535862';
export const TableHeaderText = '#6B7280';
export const DisabledText = '#383D4D';

export const Blue = '#2563EB';
export const DarkBlue = '#1D4ED8';
export const ActiveTab = '#4F8EF7';
export const Tabs = '#FFFFFF';
export const BlueFill = '#2563EB24';

export const Purple = '#977FF9';
export const LightPurple = '#D0B1E3';
export const BorderPurple = '#6465E5';
export const Selected = '#7B81EC';
export const Hover = '#9DA1F0';

export const Green = '#17B26A';
export const Notification = '#00B06D';
export const Red = '#F04438';
export const DarkRed = '#D54141';
export const ErrorIcon = '#F74141';
export const Yellow = '#EDE657';

export const ModalStroke = '#363B44';
export const PanelBackground = '#1E2127';
export const OutlineButtonBorder = '#383D47';
export const OutlineButtonText = '#9CA3AF';
export const BorderGray = '#353A41';
export const InputBorderGray = BorderGray;
export const TabDivider = '#353A4173';
export const TableHeaderBackground = Surface;
export const TableHeaderBorder = '#272B30';
export const TableBorder = BorderGray;
export const WidgetBorder = '#29292B';
export const WidgetTooltipBackground = '#29292B';
export const WidgetTooltipBorder = '#333437';
export const RemoteCardBorder = '#D5D7DA';

export const NavGray = '#D7DEE4';
export const NavGraySelected = '#E0E7EE';

export const InputLabel = '#8A8F99';
export const InputIcon = '#9EA2AE';
export const InputPlaceholder = '#4B5563';
export const InputPlaceholderDisabled = '#303539';

export const StatusOnlineBackground = '#20242B';
export const StatusOnlineBorder = '#ABEFC60D';
export const StatusOfflineBackground = '#20242B';
export const StatusOfflineBorder = '#FECDCA0D';

export const PillBlackText = '#FFFFFF';
export const PillBlackBackground = '#21242A';
export const PillBlackBorder = '#3E3F41';
export const PillOrangeText = '#E5936B';
export const PillOrangeBackground = '#443329';
export const PillPurpleText = '#9A76C6';
export const PillPurpleBackground = '#342C45';
export const PillBlueText = '#3C85C6';
export const PillBlueBackground = '#1C2E3F';
export const PillPinkText = '#FF94CF';
export const PillPinkBackground = '#42243D';
export const PillYellowText = '#B88F56';
export const PillYellowBackground = '#3A3520';
export const ButtonPurple = '#9DA1F0';
export const ButtonBorderGray = '#4A4A4A';
export const PlaceholderGray = '#B5B5B5';
